import {
  generateApplePayPaymentSession,
  proceedApplePayPayment
} from "./chunk-TXVZA2CU.mjs";

// src/hooks/wbk/booking/applePay.ts
import { useMutation } from "@tanstack/react-query";
var useApplePayPaymentSession = () => {
  return useMutation({
    mutationFn: generateApplePayPaymentSession
  });
};
var useApplePayPaymentProceed = () => {
  return useMutation({
    mutationFn: proceedApplePayPayment
  });
};

export {
  useApplePayPaymentSession,
  useApplePayPaymentProceed
};
//# sourceMappingURL=chunk-BLPWJ2KM.mjs.map